import { render, staticRenderFns } from "./labelPriceRequestStatusBadge.vue?vue&type=template&id=42c45eaf&"
import script from "./labelPriceRequestStatusBadge.vue?vue&type=script&lang=js&"
export * from "./labelPriceRequestStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports